import { CreatableResourceType, ResourceType } from "@istari-frontend/resource/model";
import { V3Models } from "@istari/istari-client";

export function fromResourceType(resourceType: CreatableResourceType): V3Models.ResourceCreateTypeDto {
  switch (resourceType) {
    case ResourceType.Model:
      return V3Models.ResourceCreateTypeDto.Model;
    case ResourceType.Artifact:
      return V3Models.ResourceCreateTypeDto.Artifact;
    case ResourceType.File:
      return V3Models.ResourceCreateTypeDto.File;
  }
}
